export default __webpack_public_path__ + "static/media/icon_a.a9dea259.svg";